import { connect } from 'react-redux';
import { browserHistory, withRouter } from 'react-router';
import { reduxForm } from 'redux-form';
import {
  fetchBriefQuestions, fetchCategoriesIfNeeded, getCategory, getSubCategory
} from 'common/ducks/categories';
import { createUserRequest, logout, GET_USER_DATA_SUCCESS, setAgencySegment } from 'common/ducks/user';
import {
  displayFullScreen, hideFullScreen, setLazyRegistering, toggleAgencyQuestion,
  LAZY_REGISTRATION_STEP, AGENCY_STEP
} from 'pap/ducks/workflow';
import { fetchDiscountCode } from 'pap/ducks/pricing';
import {
  createProjectRequest, updateProjectRequest, fetchAttachments, updateAttachments
} from 'pap/ducks/project';
import { fetchProjectIfNeeded, updateProjectLocal } from 'project/ducks/project';
import { getCurrentStepIndex } from 'pap/utils';
import { showBanner } from 'common/ducks/banner';
import { setBannerError, setUnhandledError } from 'error/ducks';
import { getVisibleBriefQuestions, getPapUrl } from 'pap_v2/utils';
import { LAZY_REGISTRATION_STEP_IDX } from 'pap_v2/constants';
import Brief from 'pap_v2/components/brief';
import {
  trackGoogle, trackMixpanel, aliasWithMixpanel, identifyWithMixpanel,
  setMixpanelProfile, mixpanelProfileFromCsProfile
} from 'common/tracking';

const mapStateToProps = ({ user, categories, pap }, { params, location }) => {
  const { fullScreen, lazyRegistering, showingAgencyQuestion } = pap.workflow;
  const { attachments } = pap.project;
  const { projectId, stepName } = params;
  const { origin='direct' } = location.query;
  const project = pap.project.projectData || {};
  let briefQuestions, categorySlug, subCategorySlug;

  if (projectId) {
    const category = getCategory(categories.data, project.category);
    const subCategory = getSubCategory(categories, project.sub_category);
    subCategorySlug = subCategory? subCategory.slug : '';
    categorySlug = category? category.slug : '';
    briefQuestions = project.brief_questions || [];
  } else {
    categorySlug = params.categorySlug;
    subCategorySlug = params.subCategorySlug;
    briefQuestions = categories.briefQuestions || [];
  }

  const questions = getVisibleBriefQuestions(briefQuestions);

  /* insert agency question if not already answered */
  if (showingAgencyQuestion) {
    questions.splice(LAZY_REGISTRATION_STEP_IDX, 0, AGENCY_STEP);
  }

  /* insert account creation step if lazy registering */
  if (lazyRegistering) {
    questions.splice(LAZY_REGISTRATION_STEP_IDX, 0, LAZY_REGISTRATION_STEP);
  }

  return {
    user,
    lazyRegistering,
    questions,
    fullScreen,
    origin,
    projectId,
    stepName,
    categorySlug,
    subCategorySlug,
    attachments,
    initialValues: projectId? {
      file_upload: attachments,
      ...project.brief_answers
    } : {},
    categories: categories.data,
    fetchingQuestions: briefQuestions.length === 0,
  }
}

/**
 * This is an async validation function that is used for both checking if an account exists with
 * given email and creating one if it doesn't.
 */
const tryCreateAccount = (values, dispatch, props) => {
  const { questions, stepName, categorySlug, subCategorySlug, setLazyRegistering } = props;

  if (stepName !== LAZY_REGISTRATION_STEP['name']) {
    return Promise.resolve();
  }

  const newAccountValues = values[stepName] || {};
  const userData = {
    is_client: true,
    email: newAccountValues.email
  };
  const currentStepIdx = getCurrentStepIndex(questions, stepName);
  const nextStepLink = getPapUrl({
    subStep: questions[currentStepIdx + 1].name,
    categorySlug,
    subCategorySlug
  });

  return createUserRequest(userData).then((response) => {
    aliasWithMixpanel(response.data.id);
    identifyWithMixpanel(response.data.id);
    setMixpanelProfile(response.data["email"], mixpanelProfileFromCsProfile(response.data), true);

    trackMixpanel("Registered", {
      "variant": "lazy",
      "userType": "client"
    });

    trackGoogle("registration", "registered", "client");

    dispatch({
      type: GET_USER_DATA_SUCCESS,
      data: response.data
    })

    /* go to next step BEFORE calling `setLazyRegistering()` otherwise there will be rendering
       errors */
    browserHistory.push(nextStepLink);
    setLazyRegistering(false);
  }).catch(({ data }) => {
    let error = null;
    if (data.email) { error = { email: data.email[0] }; }
    throw { "create-account": error };
  })
}

const wrappedBrief = reduxForm({
  form: 'pap_brief_v2',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: false,
  enableReinitialize: true,
  asyncValidate: tryCreateAccount,
  asyncBlurFields: []
})(Brief);

export default withRouter(connect(mapStateToProps, {
  fetchBriefQuestions,
  fetchCategoriesIfNeeded,
  fetchProjectIfNeeded,
  fetchAttachments,
  displayFullScreen,
  hideFullScreen,
  setLazyRegistering,
  setAgencySegment,
  createProjectRequest,
  updateProjectRequest,
  updateAttachments,
  showBanner,
  setBannerError,
  setUnhandledError,
  updateProjectLocal,
  fetchDiscountCode,
  toggleAgencyQuestion,
  logout
})(wrappedBrief));



// WEBPACK FOOTER //
// ./pap_v2/containers/brief.js